import React from 'react';
import { Card, CardBody, Button, Typography } from '@material-tailwind/react';
import { FaLock, FaArrowLeft } from 'react-icons/fa';

const EmptyState = ({ title, message, onBack }) => (
  <div className="min-h-screen bg-slate-100 p-6">
    <Card className="mx-auto mt-12 max-w-3xl shadow-lg">
      <CardBody className="p-8">
        <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-rose-50 px-3 py-1 text-xs font-semibold text-rose-700 ring-1 ring-rose-200">
          <FaLock />
          Editor unavailable
        </div>
        <Typography variant="h4" className="text-slate-900">{title}</Typography>
        <Typography className="mt-3 text-sm text-slate-600">{message}</Typography>
        <Button onClick={onBack} className="mt-6 btn-back-dark">
          <FaArrowLeft />
          Back to Monthly Invoices
        </Button>
      </CardBody>
    </Card>
  </div>
);

export default EmptyState;
